export default "__VITE_ASSET__D8PdcU3z__"